import MoneyBar from './MoneyBar'

export default MoneyBar
